import styled from 'styled-components';

export const InputsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1em;
	max-width: 25rem;
`;
